import React from "react";
import { withRouter } from "react-router-dom";
import urlResource from "./urlResource";

const withUrlResource = (WrappedComponent) => {
  const WithUrlResource = ({ location, ...props }) => (
    <WrappedComponent urlResource={urlResource(location.pathname)} {...props} />
  );
  return withRouter(WithUrlResource);
};

export default withUrlResource;
